import { privateAxios, publicAxios } from '@/services/api'

export const _downloadFile = (id) => {
    return privateAxios.get(`/translations/csv/${id}`, { responseType: 'arraybuffer' })
        .then(response => response.data)
}

export const _getTranslation = (id) => {
    return publicAxios.get(`/translations/${id}`)
        .then(response => response.data)
}
